import { render, staticRenderFns } from "./editCommunityArea.vue?vue&type=template&id=2954471b"
import script from "./editCommunityArea.vue?vue&type=script&lang=js"
export * from "./editCommunityArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports